<template>
  <div class="content new-profiles">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
      >
        <nav aria-label="breadcrumb" role="navigation">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                :to="{ name: defaultScreen ? defaultScreen : 'Search' }"
              >
                Home</router-link
              >
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'Search' }">
                Search
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Products
            </li>
          </ol>
        </nav>
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <h3 class="md-title">New Profile</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <profile-card header-color="blue">
          <template slot="header">
            <div class="card-icon"><md-icon>work</md-icon></div>
            <span class="category new-profile-card-title">Industry</span>
            <div class="new-profile-image-container">
              <img src="/img/image_placeholder.jpg" />
              <div class="image-toolbar">
                <div class="toolbar-left text-left">
                  <md-icon>info</md-icon>
                </div>
                <div class="toolbar-right text-right">
                  <md-icon
                    :key="'tab0' + key"
                    class="clickable"
                    @click.native="
                      favoriteTool(
                        'financial-profile-favourite',
                        'Industry Financial Profile'
                      )
                    "
                    :style="
                      isFavorite('financial-profile-favourite')
                        ? 'color: blue'
                        : ''
                    "
                  >
                    {{
                      isFavorite('financial-profile-favourite')
                        ? 'star'
                        : 'star_border'
                    }}
                  </md-icon>
                </div>
              </div>
            </div>
          </template>
          <template slot="content">
            <div class="info-wrap">
              <h5>Industry Financial Profile</h5>
              <p><b>Includes:</b></p>
              <ul>
                <li>US and Local</li>
                <!-- Sole Proprietorship bullet hidden until 3_26 MF/SPIF data exists — see helpers/spifAvailability.js -->
                <li>Valuation Multiples</li>
              </ul>
            </div>
            <router-link
              :to="{
                name: 'NewProfile',
                params: { id: 'industry-financial-profile' },
              }"
            >
              <md-button class="md-info md-block">Find Profiles</md-button>
            </router-link>
          </template>
        </profile-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <profile-card header-color="blue">
          <template slot="header">
            <div class="card-icon"><md-icon>work</md-icon></div>
            <span class="category new-profile-card-title">Industry</span>
            <div class="new-profile-image-container">
              <img src="/img/image_placeholder.jpg" />
              <div class="image-toolbar">
                <div class="toolbar-left text-left">
                  <md-icon>info</md-icon>
                </div>
                <div class="toolbar-right text-right">
                  <md-icon
                    :key="'tab1' + key"
                    class="clickable"
                    @click.native="
                      favoriteTool(
                        'sales-per-foot-favourite',
                        'Sales Per Square Foot'
                      )
                    "
                    :style="
                      isFavorite('sales-per-foot-favourite')
                        ? 'color: blue'
                        : ''
                    "
                  >
                    {{
                      isFavorite('sales-per-foot-favourite')
                        ? 'star'
                        : 'star_border'
                    }}
                  </md-icon>
                </div>
              </div>
            </div>
          </template>
          <template slot="content">
            <div class="info-wrap">
              <h5>Sales Per Square Foot</h5>
            </div>
            <router-link
              :to="{
                name: 'NewProfile',
                params: { id: 'sales-per-square-foot' },
              }"
            >
              <md-button class="md-info md-block">Add to Cart</md-button>
            </router-link>
          </template>
        </profile-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <profile-card header-color="blue">
          <template slot="header">
            <div class="card-icon"><md-icon>map</md-icon></div>
            <span class="category new-profile-card-title">Market</span>
            <div class="new-profile-image-container">
              <img src="/img/image_placeholder.jpg" />
              <div class="image-toolbar">
                <div class="toolbar-left text-left">
                  <md-icon>info</md-icon>
                </div>
                <div class="toolbar-right text-right">
                  <md-icon
                    :key="'tab2' + key"
                    class="clickable"
                    @click.native="
                      favoriteTool(
                        'market-profile-favourite',
                        'Industry Market Profile'
                      )
                    "
                    :style="
                      isFavorite('market-profile-favourite')
                        ? 'color: blue'
                        : ''
                    "
                  >
                    {{
                      isFavorite('market-profile-favourite')
                        ? 'star'
                        : 'star_border'
                    }}
                  </md-icon>
                </div>
              </div>
            </div>
          </template>
          <template slot="content">
            <div class="info-wrap">
              <h5>Industry Market Profile</h5>
              <p><b>Includes:</b></p>
              <ul>
                <li>Competitive Market Narratives</li>
                <li>Demographics</li>
              </ul>
            </div>
            <router-link
              :to="{
                name: 'NewMarketProfile',
              }"
            >
              <md-button class="md-info md-block">Find Profiles</md-button>
            </router-link>
          </template>
        </profile-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <profile-card header-color="blue">
          <template slot="header">
            <div class="card-icon"><md-icon>business</md-icon></div>
            <span class="category new-profile-card-title">Company</span>
            <div class="new-profile-image-container">
              <img src="/img/image_placeholder.jpg" />
              <div class="image-toolbar">
                <div class="toolbar-left text-left">
                  <md-icon>info</md-icon>
                </div>
                <div class="toolbar-right text-right">
                  <md-icon
                    :key="'tab3' + key"
                    class="clickable"
                    @click.native="
                      favoriteTool(
                        'company-profiles-favourite',
                        'Company Profiles'
                      )
                    "
                    :style="
                      isFavorite('company-profiles-favourite')
                        ? 'color: blue'
                        : ''
                    "
                  >
                    {{
                      isFavorite('company-profiles-favourite')
                        ? 'star'
                        : 'star_border'
                    }}
                  </md-icon>
                </div>
              </div>
            </div>
          </template>
          <template slot="content">
            <div class="info-wrap">
              <h5>Company Profiles</h5>
              <p><b>Includes:</b></p>
              <ul>
                <li>Prospect Lists</li>
                <li>Company Insights</li>
              </ul>
            </div>
            <router-link :to="{ name: 'FindCompanies' }">
              <md-button class="md-info md-block">Find Profiles</md-button>
            </router-link>
          </template>
        </profile-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ProfileCard } from '@/components';

export default {
  name: 'new-profiles',
  components: {
    ProfileCard,
  },
  data() {
    return {
      key: 0,
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
  methods: {
    switchView: function(type) {
      this.view = type;
    },
    isFavorite(name) {
      if (localStorage.getItem(name) === null) {
        return false;
      } else {
        return true;
      }
    },
    favoriteTool(name, title) {
      if (this.isFavorite(name)) {
        localStorage.removeItem(name);
        this.key += 1;
        this.$store.commit('INCREMENT_REFRESH_KEY');
      } else {
        localStorage.setItem(name, `${title}`);
        this.key += 1;
        this.$store.commit('INCREMENT_REFRESH_KEY');
      }
    },
  },
};
</script>
<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>
